export const DRAWER_WIDTH = 76;
export const SIDEBAR_FLYOUT_WIDTH = 240;
export const HEADER_HEIGHT = 72;

export const OFF_WHITE = "#F1EBEB";
export const SIDEBAR_BG = "#000000";
export const SIDEBAR_TEXT = OFF_WHITE;
export const SIDEBAR_TEXT_MUTED = "rgba(241, 235, 235, 0.5)";
export const SIDEBAR_SELECTED_BG = "#2E2E2E";
export const SIDEBAR_HOVER_BG = "rgba(241, 235, 235, 0.08)";

export const FLYOUT_HEADER_COLOR = "#4a6278";
export const FLYOUT_ICON_COLOR = "#1E3A5F";

export const HEADER_BG = "#FFFFFF";
export const HEADER_BORDER = "#E8E8E8";

export const DARK_NAVY = "#051525";
export const DARK_NAVY_LIGHT = "#4a6278";
export const PROFILE_FONT = '"Inter", sans-serif';
export const INPUT_BORDER_DEFAULT = "#d0dff0";
export const INPUT_BORDER_FOCUS = "#1E3A5F";
export const INPUT_FOCUS_GLOW =
  "0 0 0 3px rgba(30, 58, 95, 0.12), 0 4px 14px rgba(30, 58, 95, 0.18)";

export const FILTER_BORDER_DEFAULT = "#E0E0E0";
export const FILTER_LABEL_DEFAULT = "#9d9d9d";

export const filterFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontFamily: PROFILE_FONT,
    fontSize: 14,
    bgcolor: "#ffffff",
    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: FILTER_BORDER_DEFAULT,
      borderWidth: "1.5px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b8c9dc",
    },
    "&.Mui-focused": {
      boxShadow: INPUT_FOCUS_GLOW,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${INPUT_BORDER_FOCUS} !important`,
      borderWidth: "2px !important",
    },
  },
  "& .MuiInputLabel-root": {
    fontFamily: PROFILE_FONT,
    fontSize: 14,
    color: FILTER_LABEL_DEFAULT,
  },
  "& .MuiInputLabel-root.MuiInputLabel-shrink:not(.Mui-focused)": {
    color: `${FILTER_LABEL_DEFAULT} !important`,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: `${INPUT_BORDER_FOCUS} !important`,
  },
  "& .MuiSelect-icon": {
    color: DARK_NAVY_LIGHT,
  },
};

export const muiFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontFamily: PROFILE_FONT,
    fontSize: 14,
    bgcolor: "#ffffff",
    transition: "box-shadow 0.2s ease",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: INPUT_BORDER_DEFAULT,
      borderWidth: "2px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#b8c9dc",
    },
    "&.Mui-focused": {
      boxShadow: INPUT_FOCUS_GLOW,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${INPUT_BORDER_FOCUS} !important`,
      borderWidth: "2px !important",
    },
  },
  "& .MuiInputLabel-root": {
    fontFamily: PROFILE_FONT,
    fontSize: 14,
    color: DARK_NAVY_LIGHT,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: `${INPUT_BORDER_FOCUS} !important`,
  },
};

export const modalInputSx = {
  width: "100%",
  py: 1.25,
  px: 1.75,
  fontFamily: PROFILE_FONT,
  fontSize: 14,
  color: DARK_NAVY,
  bgcolor: "#ffffff",
  borderWidth: "1.5px",
  borderStyle: "solid",
  borderColor: FILTER_BORDER_DEFAULT,
  borderRadius: "10px",
  outline: "none",
  boxShadow: "none",
  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  "&::placeholder": {
    color: "#9d9d9d",
    opacity: 1,
  },
  "&:hover:not(:disabled):not(:focus)": {
    borderColor: "#b8c9dc",
  },
  "&:focus": {
    borderColor: INPUT_BORDER_FOCUS,
    boxShadow: INPUT_FOCUS_GLOW,
  },
  "&:disabled": {
    backgroundColor: "#f5f5f5",
    cursor: "not-allowed",
  },
};

export const nativeInputSx = {
  ...modalInputSx,
  pl: "40px",
};
